import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2'

// @TODO: Fix typing here
export default defineNuxtPlugin(({ $pinia, $localStorage }) => {
  $pinia.use(createPersistedStatePlugin({
    persist: false,
    storage: {
      getItem: (key: string) => {
        const stored = $localStorage.getItem('guts')
        const data = JSON.parse(stored)
        if (!data || !data[key]) { return null }

        return JSON.stringify(data[key])
      },
      setItem: async (key:string, value:string) => {
        const stored = $localStorage.getItem('guts')
        let data = JSON.parse(stored)
        if (!data) {
          data = {}
        }
        if (!data[key]) {
          data[key] = {}
        }

        data[key] = JSON.parse(value)
        try {
          $localStorage.setItem('guts', JSON.stringify(data))
        } catch (e) {
          console.error(e)
        }
      },
      removeItem: async (key: string) => {
        return $localStorage.removeItem(key)
      }
    }
  }
  ))
})
